export default __webpack_public_path__ + "static/session-card-bg-3-9640f5e9ba82bfea4fb3ad4fd9aab987.png";